export default __webpack_public_path__ + "static/media/Discord.faf5ce35.svg";